import type {
  DivisionItem,
  DivisionsProviderInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";

import { sleep } from "@/utils/core/sleep";

// eslint-disable-next-line no-restricted-syntax
export class DivisionsFaker implements DivisionsProviderInterface {
  async getDivisions(_id: string): Promise<DivisionItem[]> {
    await sleep();

    return [
      {
        label: "Division 001",
        value: "D-001",
      },
      {
        label: "Division 002",
        value: "D-002",
      },
      {
        label: "Division 003",
        value: "D-003",
      },
    ];
  }
}
